/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const e="esri-search-result-renderer",s={base:e,showMoreResults:`${e}__more-results--show-more-results`,moreResults:`${e}__more-results`,moreResultsList:`${e}__more-results-list`,moreResultsHeader:`${e}__more-results-header`,moreResultsItem:`${e}__more-results-item`,moreResultsListHeader:`${e}__more-results-list-header`};export{s as css};
